import { customElement, state } from 'lit/decorators.js';
import { html } from 'lit';
import { tagName } from '../../../helpers';
import { MediaPlayerBaseComponent } from '../media-player.component';
import { styles } from './video.styles';
import { baseStyles } from '../media-player.styles';

const tag = tagName('video-player');

@customElement(tag)
export class MediaPlayerVideoComponent extends MediaPlayerBaseComponent {
  static override styles = [baseStyles, styles];

  override bbwPlayout = 'basic_msp20_responsive_redesign';

  @state()
  placeholderSrc = '';

  override connectedCallback() {
    super.connectedCallback();

    if (this.usePlaceholder) {
      this.#initPlaceholderThumbnail();
    } else {
      this.initPlayer();
    }
  }

  async #initPlaceholderThumbnail() {
    const json = await this.getJson();

    const thumbnailSrc = json.clipData.thumbnails.find(
      (thumbnail: { main: boolean }) => thumbnail.main,
    )?.src;

    if (thumbnailSrc) {
      this.placeholderSrc =
        json.publicationData.defaultMediaAssetPath + thumbnailSrc;
    } else {
      this.initPlayer();
    }
  }

  override render() {
    return html`
      ${!this.playerLoaded
        ? html`<a-loader>Aan het laden...</a-loader>`
        : html`<div class="player-container">
            ${this.placeholderTemplate()}
          </div>`}
    `;
  }

  placeholderTemplate() {
    if (!this.usePlaceholder || this.placeholderSrc === '') {
      return html``;
    }

    return html`
      <div class="placeholder-container">
        <img class="placeholder-image" src="${this.placeholderSrc}" />
        <button class="placeholder-button" @click="${this.initPlayer}">
          <a-icon name="play"></a-icon>
        </button>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-video-player': MediaPlayerVideoComponent;
  }
}
